<template>
    <transition name="transitions">
        <div v-if="chatOpen">
            <!-- Chat Window -->
            <div class="chat-window">
                <div class="chat-header">
                    <h3>Chat</h3>
                    <ion-button @click="toggleChat">X</ion-button>
                </div>
                <div class="chat-body" ref="messagesBox">
                    <p class="system-message message">Welcome to the chat!</p>

                    <p v-if="isOfficeClosed" style="color: red;" class="system-message message">
                        Our Offices are currently closed. Hours: {{ convertOpenDaysToRange() }} {{
                            convertMilitaryToRegularTime(chatConfig.startHour + ":" + chatConfig.startMinute) }} to {{
                            convertMilitaryToRegularTime(chatConfig.endHour + ":" +chatConfig.endMinute) }}
                    </p>

                    <transition name="transitions" v-for="m in messages">
                        <div class="message-wrapper">
                            <p :class="'message ' + m.classes" v-html="parseMessage(m.content, m.preserve || false)">
                            </p>
                            <p class="timestamp" v-if="true">{{ m.from == "user" ? "Sent" : "Received" }}: {{
                                formatTimestamp(m.timestamp) }}</p>
                        </div>
                        <!-- Add chat messages here -->
                    </transition>
                    <transition name="transitions">
                        <p v-if="ShowMenuButtons">Choose an option:
                            <ion-buttons style="flex-wrap: wrap; gap: 2px;">
                                <ion-button id="inquire" :onclick="processInput" class="AutocompleteButton">Inquiry ???
                                    Wait till implemented</ion-button>
                                <ion-button id="apply" :onclick="processInput" class="AutocompleteButton">Job
                                    Application</ion-button>
                                <ion-button id="estimate" :onclick="processInput" class="AutocompleteButton">Request
                                    Estimate</ion-button>
                                <ion-button id="contact" :onclick="processInput"
                                    class="AutocompleteButton">Contact</ion-button>
                                <!--
                                <ion-button id="rep" :onclick="processInput" v-if="!isOfficeClosed"
                                    class="AutocompleteButton">Talk To Representative</ion-button>--><!-- IF we in theory wanted a server/socket on the other ent to use end-to-end communication-->
                            </ion-buttons>
                        </p>
                    </transition>
                </div>
                <div class="chat-footer" style="gap:10px">
                    <ion-button style="width:100%" slot="icon-only" @click="
                        () => {
                            ShowMenuButtons = !ShowMenuButtons; nextTick(() => {
                                if (messagesBox) {
                                    messagesBox.scrollTo(0, messagesBox.scrollHeight);
                                }
                            });
                        }
                    ">
                        <ion-icon :icon="outlines.menu">
                        </ion-icon>
                    </ion-button>
                    <div v-if="textEnable">

                    
                    <ion-textarea   type="text" v-model="message" placeholder="Type a message..." />
                    <ion-button slot="icon-only" :onclick="sendMessage">
                        <ion-icon :icon="outlines.send">
                        </ion-icon>
                    </ion-button></div>
                </div>
            </div>
        </div>
    </transition>
    <ion-fab-button @click="toggleChat">
        <ion-icon :icon="outlines.chatbox"></ion-icon>
    </ion-fab-button>
</template>

<script setup lang="ts">
import { ref } from "vue";
import {
    IonPage,
    IonFabButton,
    IonFab,
    IonIcon,
    IonHeader,
    IonTextarea,
    IonFooter,
    IonToolbar,
    IonButtons,
    IonSelectOption,
    IonMenuButton,
    IonButton,
    IonContent,
    IonList,
    IonItem,
    IonTitle,
    IonRow,
    IonCol,
    IonInput,
    IonToast,
    IonSelect,
    IonRadioGroup,
    IonRadio
} from "@ionic/vue";
import { onMounted, nextTick } from "vue";

import * as outlines from 'ionicons/icons';
import { chatConfig, convertMilitaryToRegularTime, convertOpenDaysToRange, isClosed, parseMessage } from "../chatHelper"
import router from "@/router";
var textEnable = ref(false)
var message = ref('');
var messages = ref<{
    from: string; classes: string[]; content: string, timestamp: number, preserve?: boolean, alert?: {
        title: string;
        message: string;
        type: 'success' | 'error' | 'info';
    }
}[]>([]);
const chatOpen = ref(false);
const isOfficeClosed = ref(false);
var ShowMenuButtons = ref(true);
var messagesBox = ref<HTMLElement>();

onMounted(() => {
    // messagesBox will be populated after mount
});
function formatTimestamp(timestamp: number): string {
    const date = new Date(timestamp);
    return date.toLocaleTimeString(); // Formats to a readable date and time
}
function sendMessage() {
    if (message.value.trim() !== '') {
        messages.value.push({
            from: 'user',
            classes: ['user-message'],
            content: message.value,
            timestamp: Date.now()
        });
        message.value = '';
    }
}
function toggleChat() {
    isOfficeClosed.value = isClosed();

    chatOpen.value = !chatOpen.value;
}


function processInput(element: PointerEvent) {
    let input: string = (element.target as Element).id || "inquire"
    messages.value.push({
        from: 'user',
        classes: ['user-message'],
        content: input.replace(/\b\w/g, c => c.toUpperCase())

        ,
        timestamp: Date.now()
    });
    if (input == "inquire") {

    } else if (input == "apply") {

        messages.value.push({
            from: 'system',
            classes: ['system-message'],
            content: "Now Redirecting you to the application page. Click <a href='/career'>Here</a> if you aren't redirected.",
            preserve: true,
            timestamp: Date.now()
        });
        setTimeout(() => {

            router.push('/career')
        }, 1000);

    } else if (input == "estimate") {
        messages.value.push({
            from: 'system',
            classes: ['system-message'],
            content: "Now Redirecting you to the estimate application page. Click <a @click='$router.push(`/requestquote`)'>Here</a> if you aren't redirected.",
            preserve: true,
            timestamp: Date.now()
        });
        setTimeout(() => {

            router.push('/requestquote')
            chatOpen.value = false;
        }, 1000);
    } else if (input == "contact") {
        messages.value.push({
            from: 'system',
            classes: ['system-message'],
            content:
                `
            Contact Us at:<br>
            <b>Atlantis Electrical Systems</b><br>
            <b>Phone:</b> <a href="tel:321-271-9197">(321)-271-9197</a><br>
            <b>Email:</b> <a href="mailto:info@aes-mlb.com" style="color:#1C8AF7">info@aes-mlb.com</a><br>
            <b>Office Location:</b> 1451 Clearmont St NE, Palm Bay, Florida, 32905<br>
            <b>Office Hours:</b><br>
            <ul>
                <li><b>Sunday: </b> Closed</li>
                <li><b>Monday: </b> 8:00 AM - 5:00 PM</li>
                <li><b>Tuesday: </b> 8:00 AM - 5:00 PM</li>
                <li><b>Wednesday: </b> 8:00 AM - 5:00 PM</li>
                <li><b>Thursday: </b> 8:00 AM - 5:00 PM</li>
                <li><b>Friday: </b> 8:00 AM - 5:00 PM</li>
                <li><b>Saturday: </b> Closed</li>
            </ul>
            <b>Services</b><br>
            <ul>
                <li><b>Emergency Services:</b> Available 24/7 for urgent electrical issues</li>
                <li><b>Service Area:</b> Serving Melbourne, Palm Bay, and surrounding areas</li>
            </ul>

            
            `

            ,
            preserve: true,
            timestamp: Date.now()
        });
        nextTick(() => {
            if (messagesBox.value) {
                messagesBox.value.scrollTo(0, messagesBox.value.scrollHeight);
            }
        });

    } else if (input == "rep") {
        messages.value.push({
            from: 'system',
            classes: ['system-message'],
            content: "Please Wait While we connect you to a representative.",
            preserve: true,
            timestamp: Date.now()
        });

    } else {


    }
    ShowMenuButtons.value = false;
}

</script>
<script lang="ts">
export default {

    name: 'Chat',

};
</script>

<style scoped>
.chat-toggle-btn {
    position: fixed;
    bottom: 20px;
    right: 20px;
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.chat-window {
    position: fixed;
    bottom: 80px;
    right: 20px;
    width: 400px;
    height:72vh;
    background-color: var(--ion-color-light);
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}


.chat-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background-color: #007bff;
    color: white;
    border-bottom: 1px solid #ccc;
}

.chat-body {
    padding: 10px;
    height: 46vh;
    overflow-y: auto;
}

.message {
    padding-top: 10px;
    padding-bottom: 10px;
    margin: 0;
    padding: 5px;
    margin-bottom: 10px;
    border-radius: 5px;

}

.chat-body .user-message,
.chat-body .admin-message {
    max-width: 200px;
    width: fit-content;
}
.chat-body .system-message {
    max-width: 47vw;
    width: fit-content;
}
.chat-body .system-message {
    background-color: var(--ion-color-medium);
    color:#1a1918;
}

.chat-body .user-message {
    margin-left: auto;
    background-color: var(--ion-color-primary);
}

.chat-body .admin-message {
    background-color: var(--ion-color-light-tint);

}

.AutocompleteButton {

    background-color: var(--ion-color-primary);
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    padding: 2px 2px;
    margin-top: 10px;
}

.chat-footer {
    display: flex;
    padding: 10px;
    border-top: 1px solid #ccc;
}

.chat-footer input {
    flex: 1;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 5px;
}

.chat-footer button {
    margin-left: 10px;
    padding: 5px 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.transitions-enter-active,
.transitions-leave-active {
    transition: opacity 0.3s, transform 0.3s;
}

.transitions-enter-from,
.transitions-leave-to {
    opacity: 0;
    transform: translateY(20px);
}

.message-wrapper .timestamp {
    display: none;
    font-size: 0.8em;
    color: #888;
    margin-top: -8px;
    margin-bottom: 8px;
}

.message-wrapper:hover .timestamp {
    display: block;
}
</style>